import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";


export const getFTPI_ImportLogsDashboard = async (params = {}) => {
  let response = await axiosInstance.get(
    API_ENDPOINTS.FTP.GET_FTP_IMPORT_LOGDASHBOARD,
    { params: { ...params } }
  );
  return response?.data;
};


export const getFTPI_ExportLogsDashboard = async (params = {}) => {
  let response = await axiosInstance.get(
    API_ENDPOINTS.FTP.GET_FTP_EXPORT_LOGDASHBOARD,
    { params: { ...params } }
  );
  return response?.data;
};



export const getFTPImportLogs = async (params = {}) => {
  let response = await axiosInstance.get(
    API_ENDPOINTS.FTP.GET_FTP_IMPORT_LONGS,
    {
      params: { ...params },
    }
  );
  return response?.data;
};

export const getFTPExportLogs = async (params = {}) => {
  let response = await axiosInstance.get(API_ENDPOINTS.FTP.GET_FTP_EXPOTLOGS, {
    params: { ...params },
  });
  return response?.data;
};



export const getOrganogramLogs = async (params = {}) => {
  let response = await axiosInstance.get(API_ENDPOINTS.FTP.GET_ORGANOGRAMLOGS, {
    params: { ...params },
  });
  console.log('OrganogramEndPoint',response?.data);
  return response?.data;
};


export const  getOrganogramTypes = async()=>{
  let response = await axiosInstance.get (API_ENDPOINTS.FTP.GET_ORGANOGRAM_TYPES)
  return  response?.data;
}

export const getOrganogramStatus  = async()=>{
  let response  = await axiosInstance.get(API_ENDPOINTS.FTP.GET_ORGANOGRAM_STATUS);
  return response?.data;
}



const ftpExportLogId = (id: number) => `?ftpExportLogId=${id}`;
export const resetFTPExport = async (id: number) => {
  const url = `${API_ENDPOINTS.FTP.PUT_RESET_FTPEXPORT}${ftpExportLogId(id)}`;
  let response = await axiosInstance.put(url);
  return response?.data;
};



const dataChangeRequestId = (id: number) => `?dataChangeRequestId=${id}`;
export const resetOrganogramLog = async (id: number) => {
  const url = `${API_ENDPOINTS.FTP.PUT_RESET_ORGANOGRAMLOG}${dataChangeRequestId(id)}`;
  
  let response = await axiosInstance.put(url);
//   response?.data;
};



const resetImportLogId = (id:number)=>`?ftpImportLogId=${id}`
export const resetImportLogd = async (id:number)=>{
       const url = `${API_ENDPOINTS.FTP.PUT_RESET_FTPIMPORT}${resetImportLogId(id)}`
       let response = await axiosInstance.put(url);
}
  